import HomePageConfigTypes from "Containers/HomePage/types"

export const getHomePagePermissionAction = payload => ({
  type: HomePageConfigTypes.GET_HOME_PAGE_PERMISSION,
  payload,
})

export const getHomePagePermissionSuccessAction = payload => ({
  type: HomePageConfigTypes.GET_HOME_PAGE_PERMISSION_SUCCESS,
  payload,
})
